import angular from 'angular';
import exportBulkAttributesModalComponent from './export.bulk.attributes.modal.component';
export default angular.module('inv.customer.orderHistory.orderDetails.exportBulkAttributesModal', []).component('exportBulkAttributesModal', exportBulkAttributesModalComponent).name;